import { computed, Directive, input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Directive()
export abstract class AlphanumericCellEditorBaseComponent {
    readonly notAdmissibleChars = input.required<string[]>();

    readonly alphanumericFormControl = input.required<FormControl>();

    readonly notAdmissibleCharsString = computed(() => '[' + this.notAdmissibleChars().join('') + ']');

    readonly notAdmissibleCharsRegexp = computed(() => new RegExp(this.notAdmissibleCharsString()));

    readonly cellReady = input.required<boolean>();
}
